<template>
    <div class="nine-dots align-self-center">
        <b-button :id="buttonId" href="#" tabindex="0" variant="link">
            <svg style="height: 1.6rem" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect x="26" width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect x="13" width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect y="26" width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect x="26" y="26" width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect x="13" y="26" width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect y="13" width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect x="26" y="13" width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect x="13" y="13" width="10" height="10" rx="2" fill="#9E9D9D"/>
            </svg>
        </b-button>
        <b-popover :id="'popover-' + buttonId" :target="buttonId" placement="bottomleft" :triggers="isMobile ? 'click' : 'hover'" custom-class="border-0 shadow nine-dots-popup">
            <div class="p-4 d-flex flex-column nine-dots-list">
                <p class="app-group-label">Business</p>
                <a :href="authUrl"  target="_blank" v-if="isProfilePageLinkVisible">
                  <img src="/img/MyAccount_01.png" alt="" width="43" height="43">
                  <span>MyAccount</span>
                </a>

              <template v-if="hasMktIt">

                <a :href="handleRchDomain(`${$xstore_url}/${$store.getters['account/user'].language.code}/customer`)"
                   v-if="isXstoreLinkVisible">
                    <img src="/img/XStore_01 1.png" alt="">
                    <span>XStore</span>
                </a>
                <a :href="`${$customer_portal_sso_url}/`" target="_blank" v-if="isCustomerPortalLinkVisible">
                    <img src="/img/CustomerPortal_01.png" alt="">
                    <span>Customer Portal</span>
                </a>
                <a :href="`${$support_url}?authorize=true`" target="_blank">
                    <img src="/img/Support_01.png" alt="">
                    <span>Support</span>
                </a>
                <a :href="handleRchDomain(`${$xdealer_url}/${$store.getters['account/user'].language.code}/dealer`)"
                   v-if="isXdealerLinkVisible">
                    <img src="/img/XDealer_01.png" alt="">
                    <span>XDealer</span>
                </a>
                <p class="app-group-label">App</p>
                <a :href="$ats_admin_url" target="_blank">
                    <img src="/img/AtsAdmin.png" alt="" width="43" height="43">
                    <span>ATS Admin</span>
                </a>
                <a :href="$rchpay_url" target="_blank">
                    <img src="/img/paySoftPOS.png" alt="">
                    <span>Pay SoftPOS</span>
                </a>
                <a :href="$smartorder_url" target="_blank">
                    <img src="/img/Smart_Order_01.png" alt="">
                    <span>SmartOrder</span>
                </a>
                <a :href="$smartplanner_url" target="_blank">
                    <img src="/img/SmartPlanner_01.png" alt="">
                    <span>SmartPlanner</span>
                </a>
                <p class="app-group-label">Marketplace</p>
                <a :href="hasCustomerRole ? `${$xmarket_url}?authorize=true` : $xmarket_url" target="_blank">
                    <img src="/img/XMarket01.png" alt="">
                    <span>XMarket</span>
                </a>

              </template>

            </div>
            <div class="px-5 py-2 text-center bg-light rounded-bottom">
                <a class="" :href="handleRchDomain(`https://www.rch.it`)">
                    <img src="/img/rch-login-logo.png" alt="" style="height: 24px;">
                    <span class="ml-2 text-black">{{ handleRchDomain(`www.rch.it`) }}</span>
                </a>
            </div>
        </b-popover>
    </div>
</template>
<script>


    export default {
        name: 'nine-dots',
        components: {},
        props: {
            isMobile: {
                type: Boolean,
                default: false
            }
        },
        computed: {
          buttonId: function (){
            return this.isMobile? 'button-link-mobile' : 'button-link'
          },
          isCustomerGroup() {
              return this.$store.getters['account/group'] === 'customer'
          },
          isDealerGroup() {
            return this.$store.getters['account/group'] === 'dealer'
          },
          hasCustomerRole() {
            return this.$store.getters['account/oidc']?.role?.includes('Customers')
          },
          hasDealerRole() {
            return this.$store.getters['account/oidc']?.role?.includes('Dealers')
          },
          authUrl() {
            return  this.$store.getters.getAuthUrl;
          },
          hasMktIt() {
            return this.$store.getters?.getAcls?.includes('mkt_it');
          },
          hasDistributor() {
            return this.$store.getters.getDealer?.has_distributor;
          },
          hasDealer() {
            return this.$store.getters.getDealer;
          },
          isProfilePageLinkVisible() {
            if (!this.authUrl) return false;

            return this.isCustomerGroup || this.isDealerGroup;
          },
          isXstoreLinkVisible() {
            return !this.isCustomerGroup && this.hasCustomerRole;
          },
          isCustomerPortalLinkVisible() {
            return this.hasDealerRole && this.hasDealer && !this.hasDistributor;
          },
          isXdealerLinkVisible() {
            return !this.isDealerGroup && this.hasDealerRole;
          },
        },
        methods: {
            handleRchDomain(url) {
                if (window.location?.hostname?.includes('rch-spa.com')) {
                    return url.replace('rch.it', 'rch-spa.com')
                } else {
                    return url
                }
            }
        },

    }
</script>
